


























































































































































































































































































































































































































































import Vue from "vue";

import fs from "fs";
import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Utils from "../../shared/Utils";
import OverlayWindow from "../general/OverlayWindow.vue";
import HtmlEditor from "../controls/HtmlEditor.vue";
import Loading from "../general/Loading.vue";
import ExpandableView from "../controls/ExpandableView.vue";
import MailingsMessageDetailsRecipients from "./MailingsMessageDetailsRecipients.vue";
import MailingsMessageDetailsRecipientSelect from "./MailingsMessageDetailsRecipientSelect.vue";

import MailingMessageJson, { MailingMessageBodyAllowedTags } from "../../shared/MailingMessageJson";
import { MailingMessageStatus, MailingMessageStatusNames } from "../../shared/MailingMessageStatus";
import MailingListJson from "../../shared/MailingListJson";
import MailingMessageRecipientInfoJson from "../../shared/MailingMessageRecipientInfoJson";
import MailingRecipientJson from "../../shared/MailingRecipientJson";
import { ClientMailingJson } from "../../shared/ClientJson";

import { UserPermissionRank } from "../../shared/UserPermissionRank";

import { ValidationResult, Validation } from "../../shared/Validation";
import { validateMailingMessageJson, validateMailingMessageJsonSend } from "../../shared/MailingMessageJson";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "MailingsMessageDetails",
  components: {
    OverlayWindow,
    HtmlEditor,
    Loading,
    ExpandableView,
    TableView,
    MailingsMessageDetailsRecipients,
    MailingsMessageDetailsRecipientSelect,
  },
  props: {
    restClient: RestClient,
    loginId: Number,
    loginPermission: Number,
    messageId: Number,
    mode: String,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      Utils: Utils,
      MailingMessageBodyAllowedTags: MailingMessageBodyAllowedTags,
      MailingMessageStatus: MailingMessageStatus,
      MailingMessageStatusNames: MailingMessageStatusNames,
      editable: false as boolean,
      detailsTitle: "",
      UserPermissionRank: UserPermissionRank,
      showSelectRecipient: false as boolean,
      selectedAdditionalRecipientIndex: null as number | null,
      detailsMode: "",
      allMailingLists: null as MailingListJson[] | null,
      selectedMessageId: null as number | null,
      messageDetails: null as MailingMessageJson | null,
      showMessageRecipients: false as boolean,
      hasChanges: false,
      toValidate: {} as any,
      validation: null as ValidationResult<MailingMessageJson> | null,
      submitValidation: false as boolean,
      loadingGeneral: false as boolean,
      loadingNextup: false as boolean,
    };
  },
  created() {
    this.initMessageDetails();
  },
  mounted() {},
  methods: {
    /*** START: details view ***/
    toggleSelectRecipient(index: number) {
      this.selectedAdditionalRecipientIndex = index;
      this.showSelectRecipient = !this.showSelectRecipient;
      if (this.showSelectRecipient == false) {
        //this.reloadData();
      }
    },
    /*** END: details view ***/

    initMessageDetails() {
      this.selectedMessageId = this.messageId;

      this.loadMailingLists();
      this.loadMessageDetails();

      this.selectDetailsMode(this.mode);
    },

    async loadMailingLists() {
      if (this.restClient != null) {
        try {
          this.allMailingLists = await this.restClient.getMailingLists();
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadMessageDetails() {
      if (this.selectedMessageId != null) {
        if (this.restClient != null) {
          try {
            this.messageDetails = await this.restClient.getMailingMessage(this.selectedMessageId);
          } catch (e) {
            alert(e.message);
          }
        }
      } else {
        this.messageDetails = this.getDefaultMessageData();
      }

      this.hasChanges = false;
    },

    reloadDetailsView() {
      if (this.selectedMessageId != null) {
        this.messageDetails = null;

        this.loadMessageDetails();
      } else {
        this.closeDetails();
      }
    },

    getDefaultMessageData() {
      return {
        ID: null,
        subject: "",
        body: "",
        isHtml: true,
        state: MailingMessageStatus.scheduled,
        broadcastDateTime: new Date().toISOString(),
        attachments: [],
        mailingLists: [],
        additionalRecipients: [],
      };
    },

    //START set cached data

    //END set cached data

    selectDetailsMode(mode: string) {
      switch (mode) {
        case "add":
          this.detailsMode = "add";
          this.detailsTitle = "Aussendung erstellen";
          this.editable = true;
          break;

        case "edit":
          this.detailsMode = "edit";
          this.detailsTitle = "Aussendung bearbeiten";
          this.editable = true;
          break;

        default:
          this.detailsMode = "read";
          this.detailsTitle = "Aussendung";
          this.editable = false;
          break;
      }
    },

    toggleEditMode() {
      this.editable = !this.editable;
    },

    stopEditMode() {
      if (!this.hasChanges) {
        this.selectDetailsMode("show");
        this.reloadDetailsView();
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.selectDetailsMode("show");
          this.reloadDetailsView();
        } else {
          //do nothing
        }
      }
    },

    closeDetails() {
      if (!this.hasChanges) {
        this.$emit("closeOverlay");
      } else {
        let c = confirm("Sie haben Änderungen vorgenommen. Durch Klicken auf OK gehen diese Änderungen verloren.");
        if (c == true) {
          this.$emit("closeOverlay");
        } else {
          //do nothing
        }
      }
    },

    inputValidation(key: any, prop: any) {
      if (prop) {
        if (!(key in this.toValidate)) {
          this.toValidate[key] = {};
        }
        this.toValidate[key][prop] = true;
      } else {
        this.toValidate[key] = true;
      }

      if (this.messageDetails != null) {
        this.validation = validateMailingMessageJson(this.messageDetails);
      }

      this.$forceUpdate();
    },

    removeValidationHint(key: any, prop: any) {
      if (key in this.toValidate) {
        if (prop) {
          delete this.toValidate[key][prop];
        } else {
          delete this.toValidate[key];
        }
      }

      this.$forceUpdate();
    },

    insertIntoMessageBody(text: string) {
      var textarea = <HTMLInputElement>this.$refs["messageDetailsBodyTextarea"];

      let start = textarea.selectionStart;
      let end = textarea.selectionEnd;

      if (this.messageDetails != null && start != null && end != null) {
        let stringEnd = this.messageDetails.body.substring(end);
        this.messageDetails.body = this.messageDetails.body.substring(0, start) + text + stringEnd;
      }
    },

    addAttachment() {
      if (this.messageDetails) {
        if (this.messageDetails.attachments.length < 5) {
          this.messageDetails.attachments.push({
            ID: null,
            fileName: "",
            data: null,
          });
        }
      }
    },

    removeAttachment(index: number) {
      if (this.messageDetails) {
        this.messageDetails.attachments.splice(index, 1);

        delete this.toValidate["attachments-" + index];
      }
    },

    async selectAttachmentFile(e: Event & { target: HTMLInputElement }, index: number) {
      if (this.messageDetails != null) {
        if (e.target && e.target.files && e.target.files.length > 0) {
          let file = e.target.files[0] as File;

          if (!file.type.match(/pdf|jpg|jpeg/)) {
            alert("Der ausgewählte Dateityp wird nicht unterstützt.");
            return;
          }

          if (file.size > 1024 * 1024 * 10) {
            alert("Die Datei darf maximal 10 MB groß sein. Bitte wählen Sie eine andere Datei aus.");
            return;
          }

          try {
            this.messageDetails.attachments[index].data = await this.convertFileToBase64(file);
            this.messageDetails.attachments[index].fileName = file.name;
          } catch (e) {
            this.messageDetails.attachments[index].data = null;
            this.messageDetails.attachments[index].fileName = "";
            alert("Es ist ein Fehler aufgetreten: " + e);
          }
        }
      }
    },

    addAdditionalRecipient() {
      if (this.messageDetails) {
        this.messageDetails.additionalRecipients.push({
          type: "ClientMailing",
          item: {} as ClientMailingJson,
        });
      }
    },

    removeAdditionalRecipient(index: number) {
      if (this.messageDetails) {
        this.messageDetails.additionalRecipients.splice(index, 1);

        delete this.toValidate["additionalRecipients-" + index];
      }
    },

    changeAdditionalRecipientType(index: number) {
      if (this.messageDetails) {
        let additionalRecipient = this.messageDetails.additionalRecipients[index];
        if (additionalRecipient.type == "ClientMailing") {
          additionalRecipient.item = {} as ClientMailingJson;
        } else if (additionalRecipient.type == "Email") {
          additionalRecipient.item = "";
        }
      }
    },

    selectRecipient(item: any, index: number) {
      if (this.messageDetails != null) {
        this.messageDetails.additionalRecipients[index]["item"] = item;

        this.inputValidation("additionalRecipients-item-" + index, "item");
      }
    },

    //START set input data (where data be cached)

    //END set input data (where data be cached)

    async sendMessage() {
      if (this.messageDetails != null) {
        this.loadingGeneral = true;
        this.submitValidation = true;

        this.validation = validateMailingMessageJsonSend(this.messageDetails);

        if (this.validation != null && this.validation.isValid == true) {
          try {
            await this.restClient.sendMailingMessage(this.messageDetails);
            alert("Die Aussendung ist für den Versand vorbereitet und wird in Kürze versendet.");
            this.$nextTick(() => {
              this.hasChanges = false;
              this.loadingGeneral = false;
              this.submitValidation = false;
              this.stopEditMode();
            });
          } catch (e) {
            this.loadingGeneral = false;
            alert(e.message);
          }
        } else {
          this.loadingGeneral = false;
          //todo Validation Error anzeigen
          alert("Aussendung ist nicht vollständig. Bitte überprüfen Sie Ihre Angaben.");
        }
      }
    },

    async deleteMessage() {
      if (this.selectedMessageId != null) {
        let c = confirm("Wollen Sie diese Aussendung wirklich unwiderruflich löschen?");
        if (c == true) {
          if (this.restClient != null) {
            try {
              await this.restClient.deleteMailingMessage(this.selectedMessageId);
              this.closeDetails();
              alert("Aussendung wurde erfolgreich gelöscht.");
            } catch (e) {
              alert(e.message);
            }
          }
        } else {
          //do nothing
        }
      }
    },

    /* async convertFileToBase64(file: File): Promise<string> {
      return new Promise(function (resolve, reject) {
        var base64String = "";

        try {
          base64String = fs.readFileSync(file.name, { encoding: "base64" });
          resolve(base64String as string);
        } catch (err) {
          reject(err);
        }
      });
    }, */

    async convertFileToBase64(file: File): Promise<string> {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.readAsDataURL(file);

        reader.onload = function () {
          if (reader != null) {
            let res = reader.result as string;
            resolve(res.slice(res.indexOf(",") + 1) as string);
          }
        };

        reader.onerror = function (error) {
          reject(error);
        };
      });
    },

    /* async convertFileToBase64(file: File): Promise<string> {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function () {
          if (reader != null) {
            resolve(reader.result as string);
          }
        };

        reader.onerror = function (error) {
          reject(error);
        };

        reader.readAsDataURL(file);
      });
    }, */
  },

  watch: {
    recipientDetails: {
      handler(val, oldVal) {
        if (oldVal != null) {
          this.hasChanges = true;
        }
      },
      deep: true,
    },
  },

  computed: {
    permissionAble: function () {
      if (this.loginPermission >= this.UserPermissionRank.management) {
        return true;
      } else {
        return false;
      }
    },
  },
});
